var getIsIE = function getIsIE() {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return !!(document && document.documentMode);
};

export { getIsIE };
